import React from 'react';

import { identificationTypes, identificationUpdateTypes } from './actions'


const initialState = {
    customers: {},
    isUpdating: false,
}

export function identification(state = initialState, action) {

    switch(action.type) {

        case identificationTypes.REQUEST:
            state = {...state}
            if (!state.customers[action.id]) {
                state.customers[action.id] = {
                    isFetching: true,
                    Customer: {},
                    done: false,
                }
            } else {
                state.customers[action.id].isFetching = true
            }
            return state

        case identificationTypes.RECEIVE:
            state = {...state}
            state.customers[action.id].Customer = action.data.Customer
            state.customers[action.id].done = true
            state.customers[action.id].isFetching = false

            return state

        case identificationUpdateTypes.REQUEST:
            state = {...state}
            state.isUpdating = true
            return state
        case identificationUpdateTypes.RECEIVE:
            state = {...state}
            state.isUpdating = false
            return state
        case identificationUpdateTypes.ERROR:
            state = {...state}
            state.isUpdating = false
            return state

        default:
            return state
    }
}